module.exports = __webpack_public_path__ + "img/Flyer-Soilmates-buitenweekend-1.ca01c198.jpg";